import React from 'react'

import AStore from "../../assets/mobile_app/AppStore.png"
import GStore from "../../assets/mobile_app/GooglePlay.png"
import { LazyLoadImage } from 'react-lazy-load-image-component'

function MobileApplications() {
    return (
        <div style={{ textAlign: "center" }} className='mt-2 d-flex gap-1' >
            <a href="https://apps.apple.com/sa/app/eyouth/id1643413327?platform=iphone" target="_blank" rel="noopener noreferrer">
                <LazyLoadImage
                    src={AStore}
                    alt="App Store"
                    style={{ height: '35px' }}
                />
            </a>
            <br />
            <a href="https://play.google.com/store/apps/details?id=org.eyouthlearning.mobile&pcampaignid=web_share" target="_blank" rel="noopener noreferrer">
                <LazyLoadImage
                    src={GStore}
                    alt="Google Play Store"
                    style={{ height: '35px' }}
                />
            </a>
        </div>

    )
}

export default MobileApplications